import type { VaultId } from "./models";

export type RelicId =
  | "golden_watch"
  | "security_blueprint"
  | "lucky_chip"
  | "museum_magnet"
  | "server_crown"
  | "ghost_seal";

export interface Relic {
  id: RelicId;
  name: string;
  description: string;
}

export const RELICS: Record<RelicId, Relic> = {
  golden_watch: { id: "golden_watch", name: "Golden Watch", description: "+5% time rewards" },
  security_blueprint: { id: "security_blueprint", name: "Security Blueprint", description: "Hazards move 5% slower" },
  lucky_chip: { id: "lucky_chip", name: "Lucky Chip", description: "+2% rare gem chance" },
  museum_magnet: { id: "museum_magnet", name: "Magnetic Core", description: "+10% pickup reach" },
  server_crown: { id: "server_crown", name: "Combo Crown", description: "+0.1s combo window" },
  ghost_seal: { id: "ghost_seal", name: "Gold Seal", description: "+2% gold earned" },
};

const vaultRelics: Record<VaultId, RelicId> = {
  street: "golden_watch",
  bank: "security_blueprint",
  casino: "lucky_chip",
  museum: "museum_magnet",
  server: "server_crown",
  ghost: "ghost_seal",
};

export const relicForVault = (vault: VaultId): Relic => RELICS[vaultRelics[vault]];

export interface RelicBonuses {
  timeScale: number;
  hazardSpeedScale: number;
  rareChanceBonus: number;
  pickupRadius: number;
  comboWindow: number;
  goldScale: number;
}

export const relicBonuses = (ids: string[]): RelicBonuses => ({
  timeScale: ids.includes("golden_watch") ? 1.05 : 1,
  hazardSpeedScale: ids.includes("security_blueprint") ? 0.95 : 1,
  rareChanceBonus: ids.includes("lucky_chip") ? 0.02 : 0,
  pickupRadius: ids.includes("museum_magnet") ? 0.1 : 0,
  comboWindow: ids.includes("server_crown") ? 0.1 : 0,
  goldScale: ids.includes("ghost_seal") ? 1.02 : 1,
});
